var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 4,
    fill: "#0066B0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12342_24942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0938 10.875H9.4375V11.6875H13.0938V10.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4688 12.9062H9.4375V13.7188H11.4688V12.9062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7188 16.5625H7.8125C7.59709 16.5623 7.39057 16.4766 7.23825 16.3243C7.08593 16.1719 7.00025 15.9654 7 15.75V9.25C7.00025 9.03459 7.08593 8.82807 7.23825 8.67575C7.39057 8.52343 7.59709 8.43775 7.8125 8.4375H14.7188C14.9342 8.43775 15.1407 8.52343 15.293 8.67575C15.4453 8.82807 15.531 9.03459 15.5312 9.25V10.898L17.7327 9.32581C17.7934 9.28237 17.8649 9.25651 17.9394 9.25106C18.0138 9.24562 18.0883 9.26081 18.1547 9.29496C18.2211 9.32911 18.2768 9.3809 18.3156 9.44464C18.3545 9.50838 18.375 9.5816 18.375 9.65625V15.3438C18.375 15.4184 18.3545 15.4916 18.3157 15.5554C18.2768 15.6191 18.2211 15.6709 18.1547 15.7051C18.0883 15.7392 18.0138 15.7544 17.9394 15.749C17.8649 15.7435 17.7934 15.7177 17.7327 15.6742L15.5312 14.102V15.75C15.531 15.9654 15.4453 16.1719 15.293 16.3243C15.1407 16.4766 14.9342 16.5623 14.7188 16.5625ZM7.8125 9.25V15.7504L14.7188 15.75V13.3125C14.7187 13.2378 14.7392 13.1646 14.7781 13.1009C14.817 13.0371 14.8726 12.9853 14.939 12.9512C15.0054 12.917 15.0799 12.9018 15.1544 12.9073C15.2288 12.9127 15.3004 12.9386 15.3611 12.982L17.5625 14.5542V10.4458L15.3611 12.0179C15.3004 12.0614 15.2288 12.0872 15.1544 12.0927C15.0799 12.0981 15.0054 12.0829 14.939 12.0488C14.8727 12.0146 14.817 11.9628 14.7781 11.8991C14.7393 11.8354 14.7187 11.7622 14.7188 11.6875V9.25H7.8125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12342_24942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBlue);
export default __webpack_public_path__ + "static/media/VideoBlue.9400496974d52bb5df64ae0c1c942b2e.svg";
export { ForwardRef as ReactComponent };